import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';


import { environment } from 'src/environments/environment';
import { Tenant } from 'src/app/models/tenant.model';
import { Surveys } from 'src/app/models/survey.model';
import { TenantViewModel } from 'src/app/models/tenant-view-model.model';
import { SurveyViewModel } from 'src/app/common/viewmodel/survey-view-model';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  
  constructor(private http: HttpClient) { }

  endpoint = environment.apiUrl;

  listTenants(): Observable<Tenant[]> {
    return this.http.get<Tenant[]>(this.endpoint + 'tenant').pipe(
      map(data => data.map(data => new Tenant().deserialize(data)))
    );
  }
  createTenant(tenant): Observable<any> {
    return this.http.post<any>(this.endpoint + 'tenant/create', tenant, this.httpOptions("default")).pipe(delay(5000));
  }

  getTenantDetails(tenantName): Observable<TenantViewModel> {
    return this.http.get<any>(this.endpoint + 'tenant/detail/'+ tenantName, this.httpOptions("response")).pipe(
      map(data => JSON.parse(data))
    );
  }
  
  deleteTenant(tenantName: string): Observable<any> {
    return this.http.post<any>(this.endpoint + 'tenant/delete', JSON.stringify(tenantName), this.httpOptions("default")).pipe(delay(5000));
  }

  jobRun(tenantName: string){
    return this.http.post<any>(this.endpoint + 'tenant/survey', JSON.stringify(tenantName), this.httpOptions("response"))
   }

   deleteSurveys(deleteSurveys: SurveyViewModel): Observable<any> {
    return this.http.post(this.endpoint + 'tenant/survey/delete', deleteSurveys, this.httpOptions("default")).pipe(
      catchError(this.handleError)
    );
  }

  deleteTenantData(tenantName: string): Observable<any> {
    return this.http.post<any>(this.endpoint + 'tenant/data', JSON.stringify(tenantName), this.httpOptions("default")).pipe(delay(5000));
  }

  private httpOptions(type: string) {
    var options = {};

    if(type == "response"){
      options = { 
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        responseType: "text" };
    } else if (type == "default") {
      options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    }

    return options;
  }
  
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` +
      `body was: ${error.error}`);
    }
    return throwError('Something bad happened; please try again later.');
  }
}
